import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
// CSS
import "./components/footer/Footer.css";

import "./core-ui/app.css";
import "./core-ui/responsive.css";
import "./core-ui/leaflet.css";
import './routes/menu/menu.css'
import './routes/efotr/emenu.css'
import './routes/contact/contact.css'
import './routes/form/form.css'
import './routes/about/aboutUs.css'
import './routes/blog/blog.css'
import './routes/prog/prog.css'
import './routes/progFotr/progfotr.css'
import './routes/prog-post/progPost.css'
import './routes/prog-postFotr/progPostFotr.css'
import './routes/cart/cart.css'
import './routes/sustainability/sustainability.css'
import './routes/registration/register.css'
import './routes/checkout/checkout.css'
import './routes/payment/payments.css'
import './routes/not-found/notFound.css'
import './routes/careers/careers.css'
import './routes/events/events.css'
import './routes/blog-post/blogPost.css'
import './routes/profile/profile.css'


//Components
import App from "./App.js";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
